import { useEffect, useState } from 'react';

import { AutocompleteOption } from '../components/Autocomplete';
import { Product } from '../data/Product';

export function useProductModelOptions(productList: Product[]) {
    const [productModelOptions, setProductModelOptions] = useState<AutocompleteOption[]>([]);

    useEffect(() => {
        setProductModelOptions(productList
            .filter((item) => item.product_model_id)
            .reduce((newProductList, item) => {
                if (!newProductList.find((nP) => nP.product_model_id === item.product_model_id)) {
                    newProductList.push({ ...item });
                }

                return newProductList;
            }, [] as Product[])
            .map((item) => ({ text: item.product_model_id, value: item.product_model_id })));
    }, [JSON.stringify(productList)]);

    return productModelOptions;
}
